export class LoadArticles {
  static readonly type = '[Blog] Load articles';
  constructor(public lang: string, public length: number) {}
}

export class LoadArticle {
  static readonly type = '[AppParams] Load article by id';
  constructor(public id: string | number) {}
}
